<template>
  <a-layout-footer class="footer">
    <p v-if="isRestaurantSelected"> {{ currentRestaurant.restaurantName }} </p>
    <p v-if="isRestaurantSelected"> Org.nr. {{ currentRestaurant.organizationNumber }} </p>
    <p>Fuji sushi Web app v2.0 ®2021 Created by Transoft </p>
    
  </a-layout-footer>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "appfooter",
  computed : {
    ...mapState({
      isRestaurantSelected: state => state.app.isRestaurantSelected
    }),
    ...mapGetters({
      currentRestaurant: "restaurants/currentRestaurant"
    })
  }

};
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
  bottom: 0;
  margin-top: auto;
  width: 100%;
}
</style>
